import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useSessionStorage } from "../../../hooks/useSessionStorage.js";
import { SelectEventTypeRenderComponents } from "./SelectEventType.js";
import { useEffect, useState } from "react";
import { Icon, MultiSelect, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useUpdateEffect } from "ahooks";
//#region src/modules/Events/shared/SearchFilterEventTypeActiveInactiveMultiSelect.tsx
var LIMIT = 25;
function SearchFilterEventTypeActiveInactiveMultiSelect({ focused, onChange, onClearSelection, onClick, value }) {
	const [eventTypesTab, setEventTypesTab] = useState("active");
	const [activeEventTypes, setActiveEventTypes] = useSessionStorage("activeEventTypesFilter");
	const [inactiveEventTypes, setInactiveEventTypes] = useSessionStorage("inactiveEventTypesFilter");
	const [totalOptions, setTotalOptions] = useState(0);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const { rpcService } = useRPCContext();
	useEffect(() => {
		if (!value?.length) {
			setActiveEventTypes(void 0);
			setInactiveEventTypes(void 0);
		}
	}, [value]);
	useEffect(() => {
		setLoading(true);
		rpcService.Events.GetEventTypesList.v1.call({
			active: eventTypesTab === "active",
			pagination: { limit: LIMIT }
		}).then(({ data }) => {
			setTotalOptions(data.total);
			setOptions(data.eventTypes);
		}).finally(() => setLoading(false));
	}, [eventTypesTab]);
	const handleLoadOptions = (opts) => {
		if (opts?.additional && options.length < totalOptions) rpcService.Events.GetEventTypesList.v1.call({
			active: eventTypesTab === "active",
			pagination: {
				limit: LIMIT,
				skip: options.length
			},
			searchText: opts.text
		}).then(({ data }) => {
			setOptions((prevOptions) => [...prevOptions, ...data.eventTypes]);
		});
		else if (opts.text) rpcService.Events.GetEventTypesList.v1.call({
			active: eventTypesTab === "active",
			pagination: { limit: LIMIT },
			searchText: opts.text
		}).then(({ data }) => {
			setOptions(data.eventTypes);
		});
	};
	useUpdateEffect(() => {
		onChange([...activeEventTypes || [], ...inactiveEventTypes || []]);
	}, [activeEventTypes, inactiveEventTypes]);
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface-strong p-xs",
		children: [/* @__PURE__ */ jsxs("div", {
			onClick,
			className: "flex w-full justify-between font-bold hover:cursor-pointer",
			children: [/* @__PURE__ */ jsx("span", { children: "Event Types" }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
		}), focused && /* @__PURE__ */ jsx("div", {
			className: "pt-xs",
			onClick: (e) => e.stopPropagation(),
			children: /* @__PURE__ */ jsxs(Tabs, {
				currentKey: eventTypesTab,
				onTabClick: setEventTypesTab,
				children: [/* @__PURE__ */ jsx(Tabs.Tab, {
					title: "Active",
					tabKey: "active",
					children: /* @__PURE__ */ jsx(MultiSelect, {
						disabled: loading,
						disableSelectAll: true,
						loading,
						loadOptions: handleLoadOptions,
						onChangeValue: (val) => {
							setActiveEventTypes(val);
						},
						onClearSelection,
						options,
						optionLabelExtractor: (option) => option.name,
						optionValueExtractor: (option) => option.id,
						placeholder: "Active Event Types",
						renderOption: SelectEventTypeRenderComponents.ListItem,
						totalOptions,
						value: activeEventTypes || []
					})
				}), /* @__PURE__ */ jsx(Tabs.Tab, {
					title: "Inactive",
					tabKey: "inactive",
					children: /* @__PURE__ */ jsx(MultiSelect, {
						disabled: loading,
						disableSelectAll: true,
						loading,
						loadOptions: handleLoadOptions,
						onChangeValue: (val) => {
							setInactiveEventTypes(val);
						},
						onClearSelection,
						options,
						optionLabelExtractor: (option) => option.name,
						optionValueExtractor: (option) => option.id,
						placeholder: "Inactive Event Types",
						renderOption: SelectEventTypeRenderComponents.ListItem,
						totalOptions,
						value: inactiveEventTypes || []
					})
				})]
			})
		})]
	});
}
//#endregion
export { SearchFilterEventTypeActiveInactiveMultiSelect };

//# sourceMappingURL=SearchFilterEventTypeActiveInactiveMultiSelect.js.map